import UserProfileView from "@/components/UserProfileView/userProfileView.component";
import BasePage from "@/infrastructure/BasePage/basePage.component";
import { Card } from "@/shadcn/components/ui/card";
import React from "react";

type UserProfilePageProps = {
  // TODO: add props here
};

const UserProfilePage: React.FC<UserProfilePageProps> = (props) => {
  return (
    <BasePage currPage="profile">
      <Card className="flex flex-col w-full h-full rounded-sm dark:bg-background">
        <UserProfileView />
      </Card>
    </BasePage>
  );
};

export default UserProfilePage;
